import { useSelector } from 'react-redux';
import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {Types, typeText} from "../../Constants/FeatureFlags/types";
import {SearchParams} from "../../Constants/FeatureFlags/searchParams";

const useEditFeatureFlag = () => {
    const enabledFeatureFlags = useSelector((state => state.SettingsReducer.enabledFeatureFlags));
    const backendFeatureFlags = useSelector((state => state.SettingsReducer.allFeatureFlags));
    const externalClients = useSelector((state => state.SettingsReducer.externalClients));
    const managedTeams = useSelector((state => state.SettingsReducer.managedTeams));
    const users = useSelector((state => state.SettingsReducer.users));
    
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedType = searchParams.get(SearchParams.Type) || null;
    const selectedFlags = searchParams.getAll(SearchParams.Flag) || null;
    const selectedId = searchParams.get(SearchParams.Id) || null;
    
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        if (!selectedType) {
            setSelectedItem(null);
            return;
        }

        if (selectedId) {
            switch (selectedType) {
                case Types.User:
                    setSelectedItem(users?.find(u => String(u.id) === String(selectedId)) || null);
                    break;
                case Types.Team:
                    setSelectedItem(managedTeams?.find(t => String(t.id) === String(selectedId)) || null);
                    break;
                case Types.Api:
                    setSelectedItem(externalClients?.find(c => String(c.id) === String(selectedId)) || null);
                    break;
                default:
                    setSelectedItem(null);
            }
            return;
        }

        if (selectedType === Types.Worker || selectedType === Types.All) {
            setSelectedItem({id: 0, userType: selectedType, name: typeText[selectedType]});
            return;
        }

        setSelectedItem(null);
        
    }, [searchParams, users, managedTeams, externalClients, selectedType, selectedId]);

    const clearSelected = () => {
        setSearchParams({});
    }
    
    return {
        enabledFeatureFlags,
        backendFeatureFlags,
        externalClients,
        managedTeams,
        users,
        selectedType,
        selectedFlags,
        selectedId,
        clearSelected,
        selectedItem
    };
};

export default useEditFeatureFlag;
